import { EntityLink } from 'labstep-web/components/Entity/Link';
import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { GroupFormShowEditDefaultProtocolCollectionTemplateProps } from './types';

export const GroupFormShowEditDefaultProtocolCollectionTemplate: React.FC<
  GroupFormShowEditDefaultProtocolCollectionTemplateProps
> = ({ group }) => (
  <FormShowEditSearchSelect
    placeholder={`Specify ${ProtocolCollection.getHumanReadableEntityName(
      false,
      false,
      true,
    )}`}
    childEntityName={ProtocolCollection.entityName}
    parentEntity={group}
    searchSelectProps={{
      params: { group_id: group.id, is_template: true },
      creatable: true,
      createBody: { group_id: group.id, is_template: true },
    }}
    childKeyName="default_protocol_collection_template"
  >
    {group.default_protocol_collection_template && (
      <div>
        <EntityLink
          entity={group.default_protocol_collection_template}
        />
      </div>
    )}
  </FormShowEditSearchSelect>
);
